import homePage from '@/components/homePage/index.vue';

export default {
  path: '/companyInfo',
  component: homePage,
  redirect: '/companyInfo/index',
  meta: { title: "账号管理" },
  children: [
    {
      path: "index",
      component: () => import('@/module/companyInfoModule/viewPage/index.vue'),
      meta: { title: "企业信息" },
    }
  ]
}